export const AuthInterceptor = (request: any) => {
  const token = localStorage ? localStorage.getItem('spacebridge_token') : null;

  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
};
